import { useLocation, useHistory } from 'react-router-dom'; // Make sure to install react-router-dom if you haven't
import { selectHotelConfig } from '../store/slice/hotelConfigSlice';
import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { DEFAULT_ROUTE_CONFIG } from '../constants';

interface routeConfig {
  route: string;
  order: number;
}

const useRouteTo = (type: 'previous' | 'next', dataToNextRoute: any = {}) => {
  try {
    const history = useHistory();
    const location = useLocation();
    const routeConfig =
      useSelector(selectHotelConfig)?.routeOrder || DEFAULT_ROUTE_CONFIG;

    const isCurrentRoute = (route: string) => {
      const pathName = location.pathname
        ?.replace('/en/', '')
        .replace('/hk/', '')
        .replace('/cn/', '')
        .replace('/jp/', '')
        .replace('/kr/', '');
      return routeConfig?.some((r: routeConfig) => {
        return r.route === pathName && r.route === route;
      });
    };

    const shouldRouteBackToAccompany = () => {
      const isBackFromAccompany = dataToNextRoute?.isBackFromAccompany;
      return (
        isBackFromAccompany &&
        (isCurrentRoute('take-document-photo') ||
          (isCurrentRoute('registration') &&
            !routeConfig.some(
              (route: routeConfig) => route.route === 'take-document-photo'
            )))
      );
    };

    const routeHandler = useCallback(() => {
      if (shouldRouteBackToAccompany()) {
        return history.push('add-guest', { isRegisteringAccompany: true });
      }

      const currentRoute = routeConfig?.find((route: routeConfig) =>
        isCurrentRoute(route.route)
      );
      const indexOfCurrentRoute = currentRoute?.order;

      const routeTo =
        type === 'previous'
          ? routeConfig?.find(
              (route: routeConfig) => route.order === indexOfCurrentRoute - 1
            )?.route
          : routeConfig?.find(
              (route: routeConfig) => route.order === indexOfCurrentRoute + 1
            )?.route;

      return history.push(routeTo, dataToNextRoute);
    }, [useHistory, useLocation, useSelector, selectHotelConfig, routeConfig]);

    return routeHandler;
  } catch (e: any) {
    console.error(e);
    throw new Error(e.message);
  }
};

export default useRouteTo;
